import React from 'react';

import { DialogActions, Heading, Paragraph, Popover, Popper, TextButton, TriggerButton } from '@zillow/constellation';
import { useCookies } from 'react-cookie';
import useQueryParams from '../../../../hooks/useQueryParams';

export const DECLINE_APPLICATIONS_POPOVER_COOKIE = 'decline_applications_popover';

export default function TakeActionTooltip() {
  const [cookies, setCookie] = useCookies([DECLINE_APPLICATIONS_POPOVER_COOKIE]);
  const hasSeenPopover = Boolean(cookies[DECLINE_APPLICATIONS_POPOVER_COOKIE]);
  const { reviewApplicationStep } = useQueryParams();

  const onClosePopover = (close) => {
    setCookie(DECLINE_APPLICATIONS_POPOVER_COOKIE, true);
    close();
  };

  const popover = (props, close) => (
    <Popover
      {...props}
      modal={false}
      renderCloseButton={null}
      onClose={() => onClosePopover(close)}
      header={<Heading level={6}>Let applicants know your decision</Heading>}
      body={
        <>
          <Paragraph>
            It’s best practice to let all applicants know whether their application was approved or declined. You can do
            that here.
          </Paragraph>
          <DialogActions>
            <TextButton onClick={() => onClosePopover(close)}>OK</TextButton>
          </DialogActions>
        </>
      }
    />
  );

  return (
    <Popper defaultOpen={!hasSeenPopover && !reviewApplicationStep} triggered={popover} placement="bottom">
      <TriggerButton aria-label="take action learn more" />
    </Popper>
  );
}
